import { render, staticRenderFns } from "./ProductosPage.html?vue&type=template&id=64d7390f&external"
import script from "./ProductosPage.vue?vue&type=script&lang=ts"
export * from "./ProductosPage.vue?vue&type=script&lang=ts"
import style0 from "./ProductosPage.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports